import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  Platform,
  TranslationsService,
} from '../translations/translations.service';
import { StepFactoryService } from '../step-factory/step-factory.service';
import { OrderingProcessService } from '../ordering-process/ordering-process.service';
import { StepVerificationService } from '../step-verification/step-verification.service';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ApplicationService {
  constructor(
    private readonly translationsService: TranslationsService,
    private readonly stepFactoryService: StepFactoryService,
    private readonly orderingProcessService: OrderingProcessService,
    private readonly stepVerificationService: StepVerificationService
  ) {}

  bootWith(language: string): Observable<void> {
    const fetchTranslations = this.translationsService.fetch(language);
    return this.translationsService.getPlatform() === Platform.desktop
      ? fetchTranslations.pipe(
          map(() => {
            const steps = this.stepFactoryService.createSteps();
            this.orderingProcessService.init(steps);
            this.stepVerificationService.init(steps);
          })
        )
      : fetchTranslations.pipe(map(() => {}));
  }

  getPlatform(): Platform {
    return this.translationsService.getPlatform();
  }
}
